export type WeldManagedField = { name: string; description: string };

const SYNCED: WeldManagedField = {
  name: "_weld_synced",
  description: "The time of the sync that last wrote this row.",
};

const DELETED_AT: WeldManagedField = {
  name: "_weld_deleted_at",
  description:
    "The time this row stopped being returned by the source. Empty while the row is still there.",
};

const UPDATED_AT: WeldManagedField = {
  name: "_weld_updated_at",
  description: "The time the source last changed this row.",
};

/**
 * The columns Weld adds to the table itself, which are not part of the source's schema. Mirrors
 * what the backend attaches to the avro schema (`avro.schema.service.ts`), so the list has to
 * follow it: `_weld_synced` always, the other two only for the settings that write them.
 */
export function weldManagedFields(stream: {
  changeDataCaptureEnabled?: boolean;
  softDeleteEnabled?: boolean;
}): WeldManagedField[] {
  if (stream.changeDataCaptureEnabled) {
    return [SYNCED, DELETED_AT, UPDATED_AT];
  }
  if (stream.softDeleteEnabled) {
    return [SYNCED, DELETED_AT];
  }
  return [SYNCED];
}
